module.exports = __webpack_public_path__ + "media/images/buybox-423d5b410da94bd3f9a835775c2e05d0.png";